import styled from 'styled-components';

export const CaseScreenHeaderContainer = styled.div`
  padding: 0 20px;
`;

export const CaseScreenHeaderDetailsColumnNew = styled.div<{
  padding?: string;
}>`
  background-color: ${(props) => props.theme.newPalette.neutral.N0};
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${({ padding }) => (padding ? `${padding}` : '0 20px')};
`;

export const HeaderSectionTitleContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 5px;
  margin: 0 0 30px 0;
`;

export const HeaderSectionTitle = styled.h2`
  ${(props) => props.theme.newTypography.textStyleDisplaySmall}
  color: ${(props) => props.theme.newPalette.neutral.N800};
  margin: 0;
`;
